import { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";
import {  getRideById, getUserInfo } from '../firebase/FirebaseManagement';
import RideCard from '../components/RideCard';
import { BsPhoneFill } from 'react-icons/bs';
export default function () {

    const {rideId} = useParams()
    const [rideDetails, setRideDetails] = useState(null)
    const [passengersArray, setPassengersArray] = useState([])
    const [passengersInfo, setPassengersInfo] = useState([])

    useEffect(() => {
        const fetchRides = async () => {
          const rides = await getRideById(rideId);
          setRideDetails(rides);
      
        };
      
      
        fetchRides();
       
      }, []);
      
      useEffect(() => {
        const fetchPassengersInfo = async () => {
            const passengersArray = rideDetails?.passengers
            setPassengersArray(passengersArray);
        }
        
        fetchPassengersInfo()

        
      },[rideDetails])

      useEffect(() => {
        const fetchPassengerIndividualInfo = async () => {
            // Ensure passengersArray is not undefined or null before proceeding
            if(passengersArray) {
                try {
                    // Promise.all will wait for all promises in the array to resolve
                    const passengersInfo = await Promise.all(
                        passengersArray.map(passenger => getUserInfo(passenger))
                    );
    
                    setPassengersInfo(passengersInfo);
                } catch (error) {
                    console.error("An error occurred while fetching passenger info: ", error);
                    // Handle the error appropriately
                    // Maybe set your state to an error state, or show a notification to the user
                }
            }
        };
    
        fetchPassengerIndividualInfo();
    }, [passengersArray]);

        console.log(passengersInfo)

  return (
    
    <div className='!gap-4 !p-[40px] max-w-[600px] m-auto flex-col items-center min-w-[300px]'>
        <h1 className='text-3xl'>Rex<span className='span-titles'>Ride</span> Details</h1>
        <RideCard rideDetails={rideDetails}/>
        <a href={`/cancelride/${rideId}`} className='block underline w-fit bg-black text-white px-3 py-1 rounded-md mt-[30px]'>Cancel Ride</a>
        <h2 className='mt-[40px]'>Passengers:</h2>
        <div className='box-container mt-[5px]'>
            {
                passengersInfo?.length > 0? 
                passengersInfo?.map((passenger) => {
                    return(
                        <div className='flex gap-4 items-center'style={{ maxHeight: '60vh', overflowY: 'auto', width: '100%' }}>
                            <img src={passenger?.file} alt="" className='w-[30px] h-[30px] rounded-full'/>
                            <p>{passenger?.firstName} {passenger?.lastName}</p>
                            <button className="flex display-row gap-2 items-center p-1 rounded-lg hover:text-white hover-bg-black active-bg-white active-text-black">
                            <BsPhoneFill />
                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{passenger?.phoneNumber}</span>
                            </button>
                        </div>
                    )
                })
                :
                "No Passengers"
            }
        </div>
        
    </div>
  )
}
